import { demoTaskPlans } from "./fixtures/task-workflow";

export type TaskClassification = "informativa" | "operativa" | "complessa";
export type TaskWorkflowStatus = "in attesa" | "modifica" | "approvata" | "rifiutata" | "annullata" | "in errore" | "completata";
export type TaskPlan = { objective: string; expectedResult: string; activities: string[] };
export type ClassifiedTask = { request: string; classification: TaskClassification; answer?: string; plan?: TaskPlan };

const wait = (milliseconds: number) => new Promise<void>((resolve) => window.setTimeout(resolve, milliseconds));

export async function classifyTaskRequest(content: string): Promise<ClassifiedTask> {
  await wait(450);
  const request = content.trim();
  if (!request) throw new Error("La richiesta non può essere vuota.");
  const lowered = request.toLowerCase();
  if (lowered.includes("errore")) throw new Error("Simulazione: la classificazione non è disponibile.");
  if (/cerca|quali|mostra|informazion|cos'è|cos’|quando|spiega/.test(lowered)) {
    return { request, classification: "informativa", answer: "È una richiesta informativa: posso rispondere senza eseguire attività." };
  }
  const classification: Exclude<TaskClassification, "informativa"> = /piano|organizza|analizza|candidatura|più attività|compless/.test(lowered) ? "complessa" : "operativa";
  return { request, classification, plan: { ...demoTaskPlans[classification], activities: [...demoTaskPlans[classification].activities] } };
}

export async function executeTaskPlan(plan: TaskPlan, request: string): Promise<{ result: string }> {
  await wait(850);
  if (request.toLowerCase().includes("fallimento")) throw new Error("Simulazione: l’esecuzione non è riuscita.");
  return { result: `Attività completate: ${plan.activities.length}. ${plan.expectedResult}` };
}
